import React from "react";
import { useState } from "react";
import styled from "styled-components";
import AuthorInformation from "components/pages/author/AuthorInformation";
import StoriesListContainer from "components/shared/containers/StoriesListContainer";
import StoriesQuery from "components/shared/queries/StoriesQuery";
import { StoryList } from "components/shared/StoryList";
import StoriesListLoader from "components/shared/spinners/StoriesListLoader";
import AuthorQuery from "components/pages/author/AuthorQuery";
import PageLoadingInterstitial from "components/shared/interstitials/PageLoadingInterstitial";
import { FooterWithState } from "components/Footer";
import { useRouter } from "next/router";
import PageContainer from "components/containers/PageContainer";
import withApollo from "components/higher-order/withApollo";
import { getNumStories } from "data/api/ApiAuthor";
import { useRecordPageView } from "hooks/analytics/useRecordPageView";
import { baseUrl } from "services/shared/Environment";
import {
  AuthorPageContextProvider,
  useAuthorPageContext,
} from "contexts/new/AuthorPageContext";
import { useRecordAuthorViewed } from "hooks/analytics/useRecordAuthorViewed";
import { useRoutingContext } from "contexts/new/RoutingContext";
import { AuthorMetaTags } from "components/shared/MetaTags/MetaTags";

const ContentContainer = styled.div`
  min-height: calc(100vh - 64px);
`;

function AuthorPage() {
  const [numStoriesShown, setNumStoriesShown] = useState(10);

  const {
    query: { slug: routerSlug },
    asPath,
  } = useRouter();
  //cast type bc we know slug will only have one value, and therefore will be type 'string' and not 'string[]'
  const slug: any = routerSlug;
  const url = `${baseUrl()}${asPath}`;

  useRecordPageView();
  const authorPageContext = useAuthorPageContext();
  const routingContext = useRoutingContext();
  useRecordAuthorViewed(authorPageContext, routingContext);

  return (
    <>
      <AuthorMetaTags authorSlug={slug} authorUrl={url} />
      <PageContainer>
        <AuthorQuery slug={slug}>
          {({ author, loading, error }) =>
            loading ? (
              <PageLoadingInterstitial loading={loading} error={error} />
            ) : (
              <>
                <ContentContainer>
                  <AuthorInformation author={author} />
                  <StoriesListContainer>
                    <StoriesQuery
                      numStories={numStoriesShown}
                      authorId={author.id}
                    >
                      {({ stories, loading }) => (
                        <>
                          <StoryList
                            useSingleColumn
                            stories={stories}
                            title={"Latest articles"}
                          />
                          {getNumStories(author) > numStoriesShown && (
                            <StoriesListLoader
                              loading={loading}
                              onClickLoad={() =>
                                setNumStoriesShown(numStoriesShown + 10)
                              }
                            />
                          )}
                        </>
                      )}
                    </StoriesQuery>
                  </StoriesListContainer>
                </ContentContainer>
                <FooterWithState />
              </>
            )
          }
        </AuthorQuery>
      </PageContainer>
    </>
  );
}

export default withApollo(() => (
  <AuthorPageContextProvider>
    <AuthorPage />
  </AuthorPageContextProvider>
));
